import { render, staticRenderFns } from "./FooterPartial.vue?vue&type=template&id=4c236715&scoped=true&"
import script from "./FooterPartial.vue?vue&type=script&lang=js&"
export * from "./FooterPartial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c236715",
  null
  
)

export default component.exports